import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";

export default function StaticPage({ titleKey, testId }) {
  const { t } = useLanguage();
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <SiteHeader />
      <main
        data-testid={testId}
        className="flex flex-1 flex-col items-start px-6 py-20 sm:px-10 lg:px-20"
      >
        <div className="mx-auto w-full max-w-3xl">
          <Link
            to="/"
            data-testid={`${testId}-back-link`}
            className="inline-flex items-center gap-2 text-sm transition-colors duration-200 hover:opacity-70"
            style={{
              color: "#1A1A1A",
              fontWeight: 500,
              letterSpacing: "0.3px",
            }}
          >
            <ArrowLeft className="h-4 w-4" />
            <span>{t("backToHome")}</span>
          </Link>
          <h1
            className="mt-12 text-[42px] leading-[1.1] sm:text-[48px]"
            style={{ color: "#1A1A1A", fontWeight: 600 }}
          >
            {t(titleKey)}
          </h1>
          <div
            className="mt-8 border border-dashed p-8"
            style={{
              borderColor: "rgba(42,38,36,0.2)",
              backgroundColor: "rgba(42,38,36,0.03)",
              borderRadius: "5px",
            }}
          >
            <p
              className="text-[17px] leading-[1.55]"
              style={{ color: "#1A1A1A", opacity: 0.7 }}
            >
              {t("placeholder")}
            </p>
            <p
              className="mt-4 font-mono text-xs"
              style={{ color: "rgba(26,26,26,0.4)" }}
            >
              [PLATZHALTER — wird vom Kunden ergänzt]
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
